import React, { useState, useMemo, useContext } from 'react'
import { intCol, numCol, strCol } from '@integec/grid-tools/lib/cols'
import CommonScreen from 'admin/component/CommonScreen'
import { monthsMap } from 'core'
import { connect } from 'react-redux'
import { Button, Input, InputNumber, message, Select } from 'antd'
import {
  modifiedDateCol,
  modifierCol,
  unitIdHeader,
} from 'core/HeaderColTypeProps'
import {
  getUtilityNameMap,
  getUnitNameMap,
  getEventTypes,
  getApiTargetInfo,
  getClientInfo,
} from 'core/selectors'
import * as api from 'api/pgads'
import moment from 'moment'
import R from 'ramda'
import { Filler, Label } from 'core/screen-util'
import MarginAnalysisUtilityUnitSelection from 'marginanalysis/MarginAnalysisUtilityUnitSelection'
import {
  PNodeZoneContext,
  UnitSelectionContext,
  ErrorContext,
  SpinContext,
} from 'context'
import { toSelectionColProps } from '@integec/grid-tools'
import { getRetrieveServiceByClient } from '../../card-data/getServiceUtil'
import LmoAdjModal from './LmoAdjModal'
const title = 'LMO Adjustment Event'

// const CustomSelect = styled(Select)`
//   .ant-select-selection--multiple {
//     max-height: 120px; /* Adjust height as needed */
//     overflow-y: auto; /* Enable scrolling when content overflows */
//   }
// `
const LMOAdjustmentEvent = ({ eventTypesData, apiTargetInfo, CLIENT }) => {
  const { spinning, setSpinning } = useContext(SpinContext)
  const [insertEvent, setInsertEvent] = useState(false)
  const [year, setYear] = useState(moment().format('YYYY'))
  // const [eventType, setEventType] = useState()
  const [card97Data, setCard97Data] = useState([])
  const [card97ModalVisible, setCard97ModalVisible] = useState(false)
  const [retrieveFunction, setRetrieveFunction] = useState(null)
  const { setError } = useContext(ErrorContext)
  const { unitIdEmktIdMap, marginUnitsList, emktIdUnitNameMap } = useContext(
    PNodeZoneContext
  )
  const { selectedUnits, setVisibleUnitSelection } = useContext(
    UnitSelectionContext
  )
  const filteredSelectedUnits = (selectedUnits || []).filter(
    u => u.unit !== '000'
  )
  const eventTypes = useMemo(_ => eventTypesData.map(e => e.eventType), [
    eventTypesData,
  ])
  const curYear = new Date().getFullYear()
  const eventTypesMap = R.compose(
    R.fromPairs,
    R.map(code => [code, code])
  )(eventTypes)
  const extraUnitSelectionProps = _ => ({
    limitedUnits: marginUnitsList,
    units: marginUnitsList,
    // itemToLabel: e => e.emktId,
  })

  const headerWithFormatter = useMemo(
    _ =>
      Headers.map(h =>
        h.ident === 'unitId'
          ? {
              ...h,
              // dataGetter: generateDataGetter,
              dataFormatter: ({ value }) => emktIdUnitNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                emktIdUnitNameMap[rowData.unitId] ||
                emktIdUnitNameMap[rowData.unitid] ||
                rowData.unitId ||
                rowData.unitid,
            }
          : h.ident === 'eventType'
          ? { ...h, ...toSelectionColProps(eventTypesMap) }
          : h.ident === 'month'
          ? {
              ...h,
              dataFormatter: ({ value }) => monthsMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                monthsMap[rowData.month] || rowData.month,
            }
          : h
      ),
    [emktIdUnitNameMap, eventTypesMap]
  )

  const screenCriteria = (s, p, u, onChange) => {
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: 24 }}>
        <div style={{ display: 'flex', gap: 8 }}>
          <Label style={{ minWidth: 60 }}>Year :</Label>
          <Select
            value={year}
            onChange={value => {
              setYear(value)
              onChange()
            }}
            style={{ width: 100 }}
          >
            {Object.keys(yearMap)
              .reverse()
              .map(i => (
                <Select.Option key={i} value={i}>
                  {yearMap[i]}
                </Select.Option>
              ))}
          </Select>
        </div>
      </div>
    )
  }

  const fetchCard97Data = currentLmoAdjData => {
    getRetrieveServiceByClient(CLIENT)(apiTargetInfo)(
      year || curYear,
      filteredSelectedUnits[0].utility,
      filteredSelectedUnits.map(u => u.unitId),
      [...eventTypes, 'CO', 'PU']
    ).fork(setError, data => {
      setSpinning(false)

      const effectibleData = (data || []).flatMap(d => {
        const startDate = moment(d.eventStart)
        const endDate = moment(d.eventEnd)
        let processedRecords = []

        // If start and end are in the same month, return a single record
        if (startDate.format('YYYY-MM') === endDate.format('YYYY-MM')) {
          processedRecords = [
            {
              ...d,
              unitId: unitIdEmktIdMap[d.unit] || d.unit,
              month: startDate.month() + 1, // Adding 1 since moment months are 0-indexed
              year: startDate.year(), // Make sure year is included
              eventNum: d.eventNum,
              modificationInfo: undefined,
            },
          ]
        }
        // If spanning multiple months, create a record for each month
        else {
          const months = []
          let currentDate = startDate.clone().startOf('month')
          const lastMonth = endDate.clone().startOf('month')

          while (currentDate <= lastMonth) {
            months.push({
              year: currentDate.year(),
              month: currentDate.month() + 1, // Adding 1 since moment months are 0-indexed
            })
            currentDate = currentDate.clone().add(1, 'month')
          }

          processedRecords = months.map(({ year, month }) => ({
            ...d,
            year,
            unitId: unitIdEmktIdMap[d.unit] || d.unit,
            month,
            eventNum: d.eventNum,
            modificationInfo: undefined,
          }))
        }

        // Match with lmoAdjData and add lmoAdjustment and comments
        return processedRecords.map(record => {
          const matchingLmoAdj = (currentLmoAdjData || []).find(
            lmo =>
              String(lmo.unitId) === String(record.unitId) &&
              String(lmo.year) === String(record.year) &&
              String(lmo.month) === String(record.month) &&
              String(lmo.eventNum) === String(record.eventNum)
          )

          if (matchingLmoAdj) {
            return {
              ...record,
              lmoAdjustment: matchingLmoAdj.lmoAdjustment,
              comments: matchingLmoAdj.comments || '',
            }
          }

          return record
        })
      })

      setCard97Data(effectibleData)
      setCard97ModalVisible(true)
    })
  }

  const onRetrieveCard97Data = ({ lmoAdjData, onRetrieve }) => {
    // Store the retrieve function for later use when modal closes
    if (onRetrieve) {
      setRetrieveFunction(() => onRetrieve)
    }

    // Check if units are selected
    if (selectedUnits.length <= 0) {
      setVisibleUnitSelection(true)
      message.warning('Please Select Units')
      return
    }

    if (filteredSelectedUnits.length <= 0) {
      setVisibleUnitSelection(true)
      message.warning('Please Select Non Roll Up Units')
      return
    }

    setSpinning(true)

    // If lmoAdjData is empty, get the data first
    if (!lmoAdjData || lmoAdjData.length <= 0) {
      api
        .getLMOAdjustmentEvent(apiTargetInfo)({
          year: year || curYear,
          units: (selectedUnits || [])
            .filter(e => !!e)
            .map(e => unitIdEmktIdMap[e.unitId]),
        })
        .fork(
          error => {
            setError(error)
            fetchCard97Data([])
          },
          freshLmoAdjData => {
            fetchCard97Data(freshLmoAdjData || [])
          }
        )
    } else {
      // If lmoAdjData is already available, directly proceed with card97 data
      fetchCard97Data(lmoAdjData)
    }
  }
  // const extraCriteria = () => {
  //   return (
  //     <CriteriaRow
  //       style={{
  //         display: 'grid',
  //         gridTemplateColumns: '300px auto',
  //         alignItems: 'center',
  //         marginBottom: 12,
  //         gap: 20,
  //       }}
  //     >
  //       <div>
  //         <Label style={{ minWidth: 90 }}>Event Type :</Label>
  //       </div>
  //       <CustomSelect
  //         placeholder="Select Event Type"
  //         allowClear
  //         showSearch
  //         mode="multiple"
  //         value={eventType}
  //         onChange={setEventType}
  //         style={{ width: '90%' }}
  //       >
  //         <Select.Option value="ALL">ALL</Select.Option>
  //         {eventTypes.map(type => (
  //           <Select.Option key={type} value={type}>
  //             {type}
  //           </Select.Option>
  //         ))}
  //       </CustomSelect>
  //     </CriteriaRow>
  //   )
  // }

  const extraCriteriaAfterButton = ({ data, onRetrieve }) => {
    const handleButtonClick = () => {
      onRetrieveCard97Data({ lmoAdjData: data, onRetrieve })
    }

    return (
      <Button
        type="primary"
        style={{ marginLeft: '10px' }}
        onClick={handleButtonClick}
        icon="database"
      >
        Card 97 - Event Data
      </Button>
    )
  }

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '200px 200px 200px 200px 200px 200px 200px 200px',
        gap: 10,
      }}
    >
      <div>
        <Label style={{ display: 'inline', float: 'right' }}>
          Utility / Unit :
        </Label>
        <span style={{ color: 'red', marginRight: '2px', float: 'right' }}>
          *
        </span>
      </div>
      <div style={{ gridColumn: 'span 3' }}>
        <MarginAnalysisUtilityUnitSelection
          utility={insertData.utility || null}
          unit={insertData.unit || null}
          onUnitChange={value => {
            // setUtilityUnit(value)
            setInsertData({
              ...insertData,
              utility: value[0],
              unit: value[1],
              unitId: unitIdEmktIdMap[value[1]],
            })
          }}
          style={{ width: '100%' }}
        />
      </div>
      <div>
        <Label style={{ display: 'inline', float: 'right' }}>Year :</Label>
        <span style={{ color: 'red', marginRight: '2px', float: 'right' }}>
          *
        </span>
      </div>
      <Select
        showSearch
        value={insertData.year}
        onChange={year => setInsertData({ ...insertData, year })}
      >
        {Object.keys(yearMap)
          .reverse()
          .map(i => (
            <Select.Option key={i} value={i}>
              {yearMap[i]}
            </Select.Option>
          ))}
      </Select>

      <div>
        <Label style={{ display: 'inline', float: 'right' }}>Month :</Label>
        <span style={{ color: 'red', marginRight: '2px', float: 'right' }}>
          *
        </span>
      </div>
      <Select
        value={insertData.month}
        onChange={month => setInsertData({ ...insertData, month })}
      >
        {Object.entries(monthsMap).map(([num, name]) => (
          <Select.Option key={num} value={num}>
            {name}
          </Select.Option>
        ))}
      </Select>

      <div>
        <Label style={{ display: 'inline', float: 'right' }}>
          Event Number :
        </Label>
        <span style={{ color: 'red', marginRight: '2px', float: 'right' }}>
          *
        </span>
      </div>
      <InputNumber
        style={{ width: '100%' }}
        value={insertData.eventNum}
        onChange={e => setInsertData({ ...insertData, eventNum: e })}
      />

      <div>
        <Label style={{ display: 'inline', float: 'right' }}>
          Event Type :
        </Label>
      </div>
      <Select
        value={insertData.eventType}
        onChange={eventType => setInsertData({ ...insertData, eventType })}
      >
        {eventTypes.map(type => (
          <Select.Option key={type} value={type}>
            {type}
          </Select.Option>
        ))}
      </Select>

      <div>
        <Label style={{ display: 'inline', float: 'right' }}>
          LMO Adjustment :
        </Label>
      </div>

      <InputNumber
        style={{ width: '100%' }}
        value={insertData.lmoAdjustment}
        onChange={e => setInsertData({ ...insertData, lmoAdjustment: e })}
      />
      <Filler />
      <Filler />
      <div>
        <Label style={{ display: 'inline', float: 'right' }}>Comments :</Label>
      </div>

      <Input.TextArea
        style={{ gridColumn: 'span 3' }}
        value={insertData.comments}
        onChange={e =>
          setInsertData({ ...insertData, comments: e.target.value })
        }
        autoSize={{ minRows: 1, maxRows: 4 }}
      />

      <Button
        type="primary"
        style={{ marginLeft: '50px' }}
        onClick={() => onAdd(true)}
      >
        Add
      </Button>
      <Button
        type="primary"
        style={{ marginLeft: '50px' }}
        onClick={() => onAdd(false)}
      >
        Add & Hide
      </Button>
      <Button type="danger" style={{ marginLeft: '50px' }} onClick={onCancel}>
        Cancel
      </Button>
    </div>
  )

  const withCriteria = (state, props, selectedUnits) => {
    return {
      year: year,
      // eventTypes: eventType.includes('ALL')
      //   ? eventTypesData.map(e => e.eventType)
      //   : eventType,
      units: (selectedUnits || [])
        .filter(e => !!e)
        .map(e => unitIdEmktIdMap[e.unitId]),
    }
  }

  return (
    <>
      <CommonScreen
        title={title}
        header={headerWithFormatter}
        // extraCriteria={extraCriteria}
        extraCriteriaAfterButton={extraCriteriaAfterButton}
        screenCriteria={screenCriteria}
        saveTask={api.saveLMOAdjustmentEvent}
        retrieveTask={api.getLMOAdjustmentEvent}
        deleteTask={api.deleteLMOAdjustmentEvent}
        extraUnitSelectionProps={extraUnitSelectionProps}
        withUnitSelection
        altBy={d => d.unitId}
        withCriteria={withCriteria}
        autoRetrieve={false}
        sortOptions={Headers}
        widthOffset={50}
        heightOffset={270}
        // totalWidth={1200}
        insertComp={insertEvent && insertComp}
        onInsertEvent={b => setInsertEvent(b)}
        autoFixColByKey={false}
        headerRowHeight={60}
      />
      <LmoAdjModal
        visible={card97ModalVisible}
        data={card97Data}
        spinning={spinning}
        setLoading={setSpinning}
        apiTargetInfo={apiTargetInfo}
        onClose={() => {
          setCard97ModalVisible(false)
          if (retrieveFunction) {
            retrieveFunction()
          }
        }}
      />
    </>
  )
}

const mapStateToProps = state => ({
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
  eventTypesData: getEventTypes(state),
  apiTargetInfo: getApiTargetInfo(state),
  CLIENT: getClientInfo(state),
})

export default connect(mapStateToProps)(LMOAdjustmentEvent)

export const Headers = [
  unitIdHeader,
  intCol({
    ident: 'eventNum',
    display: 'Event Number',
    isKey: true,
    sortOrder: 'asc',
    width: 100,
  }),
  intCol({
    ident: 'year',
    display: 'Year',
    isKey: true,
    sortOrder: 'desc',
    dropdown: true,
  }),
  intCol({
    ident: 'month',
    display: 'Month',
    isKey: true,
    sortOrder: 'asc',
    dropdown: true,
  }),
  strCol({
    ident: 'eventType',
    display: 'Event Type',
    isFiltered: true,
    width: 60,
  }),
  numCol({
    ident: 'lmoAdjustment',
    display: 'LMO Adjustment',
    isFiltered: true,
    displayFormat: '0.00',
    width: 150,
    // isRequired: true,
  }),
  strCol({
    ident: 'comments',
    display: 'Comments',
    isKey: false,
    ellipsis: true,
    width: 500,
  }),
  modifierCol,
  modifiedDateCol,
]

export const yearMap = R.compose(
  R.fromPairs,
  R.map(a => [a, a + ''])
)(R.range(-15, 10).map(a => a + moment().year()))
